<template>
    <base-form :formType="'EditRegister'">
     
    </base-form>
  </template>
  
  <script>
  import BaseForm from "./BaseForm.vue";
  
  export default {
    components: { BaseForm },
    data() {
      return {
      };
    },
    mounted(){
      this.initShare();
        this.$dataStatistics({
            page_title: `会员编辑`,
        },'访问');
    },
  };
  </script>